import { render } from "./PanelAIPressResult.vue?vue&type=template&id=1e91055d&scoped=true"
import script from "./PanelAIPressResult.vue?vue&type=script&lang=js"
export * from "./PanelAIPressResult.vue?vue&type=script&lang=js"

import "./PanelAIPressResult.vue?vue&type=style&index=0&id=1e91055d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e91055d"]])

export default __exports__